type AdvantageCardProps = {
  icon: string;
  title: string;
  description: string;
  tinted?: boolean;
};

export const AdvantageCard = ({ icon, title, description, tinted = false }: AdvantageCardProps) => {
  return (
    <div
      className={`flex flex-col justify-between h-full min-h-[240px] lg:min-h-[360px] rounded-[28px] lg:rounded-[36px] px-7 py-7 lg:px-10 lg:pt-10 lg:pb-14 shadow-[0_6px_30px_rgba(0,0,0,0.05)] ${
        tinted ? "bg-[#F7EFEE] border-[5px] border-white" : "bg-white"
      }`}
    >
      <img src={icon} alt="" aria-hidden="true" className="w-[44px] h-[44px] lg:w-[62px] lg:h-[62px] object-contain" />
      <div className="mt-10">
        <h3 className="text-[#171717] text-[20px] lg:text-[30px] leading-[1.2]">{title}</h3>
        <p className="mt-[12px] lg:mt-6 text-[#222] text-[15px] lg:text-[20px] leading-[1.4]">{description}</p>
      </div>
    </div>
  );
};
